import React, { Component } from 'react';
import { Jumbotron } from 'react-bootstrap';

// TODO: rewrite component to functional, because it stateless
// eslint-disable-next-line react/prefer-stateless-function
export default class AcceptDelivery extends Component {
  render() {
    return (
      <Jumbotron>
        <h1>Exciting News!</h1>
        <p>
          This action is no longer necesary. If you have an issue that deviates
          from normal operation please let the Tech team know
        </p>
      </Jumbotron>
    );
  }
}
